// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"h7","header":"h8","overTitle":"h9","image":"h-","title":"h_","description":"ia","button":"ib"};